export const TASK_STORE = 'TASK_STORE';
export const TASK_UPDATE = 'TASK_UPDATE';
export const TASK_DESTROY = 'TASK_DESTROY';
